import { render, staticRenderFns } from "./CreateNewUserDialog.vue?vue&type=template&id=2d8ae2c2&scoped=true&lang=pug&"
import script from "./CreateNewUserDialog.vue?vue&type=script&lang=ts&"
export * from "./CreateNewUserDialog.vue?vue&type=script&lang=ts&"
import style0 from "./CreateNewUserDialog.vue?vue&type=style&index=0&id=2d8ae2c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8ae2c2",
  null
  
)

export default component.exports